import React from 'react';
import './FiltersSidebar.css';

const FiltersSidebar = () => {
    const filters = [
        "Shortlisted",
        "Favorites",
        "Rejected",
        "Counter BID",
        "Counter BID Accepted",
        "Counter BID Rejected",
    ];

    return (
        <div className="filters-card">
            <div className="filters-header">
                <h4>Filters</h4>
            </div>
            <ul className="filters-list">
                {filters.map((item, index) => (
                    <li key={index} className="filter-item">{item}</li>
                ))}
            </ul>
        </div>
    );
};

export default FiltersSidebar;
